const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/custom_logins/debug_sessions/$uuid.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_minimal/custom_logins/debug_sessions/$uuid")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});